import { Injectable } from '@angular/core';
import { AbstractTrackEventsService } from './abstract-track-events.service';

@Injectable()
export class TrackEventsServiceStub extends AbstractTrackEventsService {
  trackEvent(event: Record<string, unknown>): void {
    console.log('[TrackEvent]', event);
  }
}
